{
  "jsm-phantom.jira-space-settings-playbooks-navigation-spotlight.screen-space-flags.description.no-translate": [
    {
      "type": 0,
      "value": "Replace this with a short summary of what this message tells the recipient."
    }
  ],
  "jsm-phantom.jira-space-settings-playbooks-navigation-spotlight.screen-space-flags.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-close-button": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-first-line": [
    {
      "type": 0,
      "value": "Follow step-by-step guidance and run automate actions to resolve work faster."
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-heading": [
    {
      "type": 0,
      "value": "Resolve work items faster with playbooks"
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more about playbooks"
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-second-line": [
    {
      "type": 0,
      "value": "No playbook yet? Share your runbooks with project admin to turn them into actionable playbooks."
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-close-button": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-first-line": [
    {
      "type": 0,
      "value": "Create reusable playbooks from runbooks, SOPs, and how-tos to give your team step-by-step guidance and automated actions to resolve work items faster, right in context."
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-heading": [
    {
      "type": 0,
      "value": "Turn your team’s knowledge into playbooks"
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more about playbooks"
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight.create-playbook": [
    {
      "type": 0,
      "value": "Create playbook"
    }
  ]
}